import { TeamRole } from '@anm/api/modules/team';
import { FC } from 'react';

import RadioLabel from './RadioLabel';
import { RadioButtonWrapper } from './Wrapper';

export type RoleRadioBlockProps = {
  label: string;
  value: TeamRole;
  isChecked: boolean;
  features: string[];
  onChange: (value: string) => void;
};

const RoleRadioBlock: FC<RoleRadioBlockProps> = ({ label, value, isChecked, features, onChange }) => (
  <RadioButtonWrapper
    key={value}
    name="role"
    label={<RadioLabel label={label} features={features} />}
    {...{ value, isChecked, onChange }}
  />
);

export default RoleRadioBlock;
